'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { userEarnPositionsQueryOptions } from '@/hooks/positions/userEarnPositionsQuery';

/**
 * Earn positions for the dashboard Earn hero. It shares the positions table's query, so the hero
 * cards and the table make one request, and every position is included so totals and the network
 * selector cover the whole portfolio.
 */
export const useDashboardEarnPositions = accountAddress => {
  const $ = _c(10);
  let t0;
  if ($[0] !== accountAddress) {
    t0 = userEarnPositionsQueryOptions(accountAddress);
    $[0] = accountAddress;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0,
      refetchInterval: 10000
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t1);
  let t2;
  if ($[4] !== data?.items) {
    t2 = data?.items ?? [];
    $[4] = data?.items;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isError || $[7] !== isLoading || $[8] !== t2) {
    t3 = {
      earnPositions: t2,
      loading: isLoading,
      isError
    };
    $[6] = isError;
    $[7] = isLoading;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};